/**
 * The bot was in the room and never answered `client-ready` (FLO-1140).
 *
 * A class of its own so a caller can tell this failure from every other
 * rejected connect by type, never by message text: diagnostics forward a
 * reason code, not exception strings.
 */
export class RtviHandshakeTimeoutError extends Error {
  constructor(timeoutMs: number) {
    super(`The Floe bot did not answer client-ready within ${timeoutMs}ms`);
    this.name = 'RtviHandshakeTimeoutError';
  }
}
